<template>
  <div :id="galleryID">
    <div class="chat-widget__gallery-item">
      <a

          :href="image.url"
          :data-pswp-width="image.width"
          :data-pswp-height="image.height"
          target="_blank"
          rel="noreferrer"
      >
        <img style="width: 100%" :src="image.url" alt=""/>
      </a>
      <div v-if="image.mime_type === SVG_MIME_TYPE">
        <Button variant="text" type="button" icon="pi pi-download" label="" class="chat-widget__gallery-item--download"
                @click="toggle"/>

        <Popover ref="popover">
          <Button severity="secondary" text type="button" icon="" label="SVG"
                  @click="exportSvg"/>
          <Button severity="secondary" type="button" icon="" label="PNG"
                  text
                  @click="exportPng"/>
        </Popover>
      </div>
      <Button severity="secondary" type="button" icon="" label="PNG"
              text
              v-else
              @click="(e) => downloadFile(image.url, image.filename)"/>
    </div>
  </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from 'vue';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import Button from 'primevue/button';
import Popover from "primevue/popover";
import {SVG_MIME_TYPE} from "@/constants";
import {downloadFile} from "@/services/helper";
import {convertSvgToPng} from "@/modules/chat/services/image";

// Props are directly accessible in the <script setup>
const props = defineProps({
  galleryID: String,
  image: Object
});

let lightbox;

onMounted(() => {
  lightbox = new PhotoSwipeLightbox({
    gallery: `#${props.galleryID}`,
    children: 'a',
    pswpModule: () => import('photoswipe'),
  });
  lightbox.init();
});

onUnmounted(() => {
  if (lightbox) {
    lightbox.destroy();
    lightbox = null;
  }
});

const popover = ref();

const toggle = (event) => {
  popover.value.toggle(event);
};

const downloadPng = (url) => {
  convertSvgToPng(url)
      .then((res) => {
        // Создаем ссылку для скачивания
        const link = document.createElement('a');
        link.download = 'image.png';
        link.href = res;
        link.click();
      })
      .catch((e) => console.log(e));
};

const exportPng = () => {
  downloadPng(props.image.url);
  toggle();
};

const exportSvg = () => {
  const {image} = props;
  downloadFile(image.url, image.filename);
  toggle();
};
</script>
